import React from "react";
import { useSavings } from "../../context/SavingsContext";
import {
  calculateMonthlyRecurringSavings,
  calculateAnnualProjection,
} from "../../utils/calculations";

const RecurringSavings: React.FC = () => {
  const { data } = useSavings();
  const monthlySavings = calculateMonthlyRecurringSavings(data.entries);
  const annualProjection = calculateAnnualProjection(data.entries);

  const formatCurrency = (amount: number): string => {
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };

  return (
    <div className="bg-gray-900 p-6 rounded-lg">
      <h2 className="text-xl mb-4">Monthly Recurring Savings</h2>
      <div className="text-4xl font-bold text-green-400 mb-2">
        {formatCurrency(monthlySavings)}
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-400">Monthly</span>
        <span className="text-gray-400">
          Annual Projection:{" "}
          <span className="text-green-400 font-semibold">
            {formatCurrency(annualProjection)}
          </span>
        </span>
      </div>
    </div>
  );
};

export default RecurringSavings;
